import { BASE_URL } from '../../ApiCall/BaseUrl';

const fileDownloader = (path?: string) => {
  if (!path) return;
  // const base = `/upload/${path}`.split("\\").join("%5C%5C");
  const base = `${path}`.split('/').join('%2F').split('\\').join('%5C%5C');

  return BASE_URL + '/upload' + `?path=${base}`;
};

export default fileDownloader;
